import "animate.css";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
import colorSharp2 from "../assets/img/color-sharp2.png";
import projImg3 from "../assets/ProjectImages/master.png";
import projImg1 from "../assets/ProjectImages/phone-refurb.png";
import projImg2 from "../assets/ProjectImages/Photo-Fix.png";
import { ProjectCard } from "./ProjectCard";

export const Projects = () => {
  const projects = [
    {
      id: 1,
      title: "Phone Refurb",
      features:
        "In this SPA web app you will find various categories related to the Second-Hand Mobile Phone. Which are focued on buy,sell and exchange. The interactive navbar consists of few routes including a login, logout icon which toggles based on user interactivity. There are 3 different user feature in this app, Admin - Who can see all the sellers and buyers and manage them from the interactive sidebar. Seller - Who can see all of his posted Products and a Add A Product Form. Buyer - Who can see his orders, also the products advertised by the seller at the home page.Buyer can pay price using their card by pressing pay button. This feature built using stripe. There are 3 different categories at the home page and each category has its own set of products. At the /dashboard route you'll find a greetings page. In the blog page you'll find tech related blogs It has very basic signup and signin page and where you can upload your photo directly from your computer or mobile devices.",
      description:
        "This app is a full-stack(MERN). In this SPA web app you will find various categories related to the Second-Hand Mobile Phones. 3 different user ui like admin seller and buyer. All the different routes are protected both in back & front-end.",
      imgUrl: projImg1,
      live: "https://phone-refurb.web.app/",
      client: "https://github.com/HasanMdKamrul/phone-refurb",
      server: "https://github.com/HasanMdKamrul/phone-refurb-server",
      screenShots: [
        "https://i.ibb.co/BjW6L44/phoneRe1.png",
        "https://i.ibb.co/7rFqdks/phoneRe2.png",
        "https://i.ibb.co/HKqgNCG/phoneRe3.png",
      ],
    },
    {
      id: 2,
      title: "Photo-Fix",
      features: `In this SPA web app you will find various services related to the photography of an individual photographer. Which are focued on single photographer with a lots of offerings.The interactive navbar consists of few routes including a login, logout icon which toggles based on user interactivity at the sharp right corner.In the service details page you can give review about the services you took.
    At the home component you will find banner,services,recent works and about me section.
    On the services page you'll find all the services this single photograpger is offering, on the other hand in the home page you will find just 3 services, where the most recent one comes first.
    By clicking see details you can go to the service details page .
    There you will find the detail info about the service this platfrom is offering, also you can see reviews that other people has given at the end you can also give your feedback if you are logged in.
    Your feedback instantly update and shown, also you can see only the service specific reviews in this details page.
    At My Reviews page you will find all the reviews you have given about different services, with their name specific as well . You can also edit and delete your review if you wish.
    In the blog page you'll find tech related blogs.
    At the Add Service page you can add a new service by providing usefull informations.
    React lazy load and suspance implemented to give the user a better exprerience which the big chunk of data load from the api.
    In the password section you'll get an eye icon to show or hide your password by clicking.
    You can reset your password as well if you forgot
    By clicking on the images in the card and gallary section you can see the bigger or the full length images.`,
      description:
        "PhotoFix is a MERN app, used firebase authentication and private routing.MongoDb used as database and basic curd operation implemented, where user can make review and also give them star ratings. Many useful features like pagination is also there.",
      imgUrl: projImg2,
      live: "https://photo-fix-393b3.web.app/",
      client: "https://github.com/HasanMdKamrul/photo-fix-app",
      server: "https://github.com/HasanMdKamrul/photo-fix-server",
      screenShots: [
        "https://i.ibb.co/Dtbzs1d/Screenshot-2022-12-10-at-9-54-16-PM.png",
        "https://i.ibb.co/sV0TKMC/Screenshot-2022-12-10-at-9-54-36-PM.png",
        "https://i.ibb.co/RzrK0Bb/Screenshot-2022-12-10-at-9-54-52-PM.png",
      ],
    },
    {
      id: 3,
      title: "Mastering-Ai",
      features: `In this SPA web app you will find various courses related to the AI. Which are focued on learning and a beautiful ui which will navigate you smoothly.

      The interactive navbar consists of few routes including a login, logout icon which toggles based on user interactivity. Besides the profile photo with the link as an avatar appears when the user logged in.
      
      In the profile page you can edit the profile information such as profile picture and the name.
      
      In the first page of the UI, you'll find two buttons if you're not signuped or logged in.
      
      One of them is Buy courses -> which will navigate you to the courses page.Another button is the sign up button, which you can use if you're new to the platform.
      
      At the home component I have dynamically shown information about the instructors
      
      On the courses page you'll find several courses card at the left and course outline at the right nav.
      
      By clicking those you can go to the course details page .
      
      There you will find the detail info about the course this platfrom is offering, also you can download the detail info by clicking the dowload icon.
      
      By using the get premium access you can easily purchased your desired course.
      
      At the end you'll find a greetings page.
      
      In the blog page you'll find tech related blogs
      
      At the FAQ page you'll get FAQs.
      
      I have also included a find button, which will redirect you to the find route where you will find a map to get to us and a mailing platform to talk to us.
      
      React lazy load and suspance implemented to give the user a better exprerience which the big chunk of data load from the api.
      
      You can find the courses according to their categories in the courses page.
      
      In the password section you'll get an eye icon to show or hide your password by clicking.
      
      You can reset your password as well if you forgot`,
      description:
        "This application provides courses to buy. Where you can categorised the courses on the courses page. Upon clicking the courses you can see details of them and can download the features as PDF. Many technologies like react leaflet, React-to pdf used.",
      imgUrl: projImg3,
      live: "https://mastering-ai-app.web.app/",
      client: "https://github.com/HasanMdKamrul/mastering-ai-app",
      server: "https://github.com/HasanMdKamrul/mastering-ai-server",
      screenShots: [
        "https://i.ibb.co/sjY90Qx/Screenshot-2022-12-10-at-9-59-14-PM.png",
        "https://i.ibb.co/Yh1TSYB/Screenshot-2022-12-10-at-9-59-26-PM.png",
        "https://i.ibb.co/LnXMLWp/Screenshot-2022-12-10-at-9-59-40-PM.png",
      ],
    },
  ];

  return (
    <section className="project" id="Project">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Projects</h2>
                  <p>My Projects are listed below!</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav
                      variant="pills"
                      className="nav-pills mb-5 justify-content-center align-items-center"
                      id="pills-tab"
                    >
                      <Nav.Item>
                        <Nav.Link eventKey="first">FullStack</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Upcoming</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Upcoming</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id="slideInUp"
                      className={
                        isVisible ? "animate__animated animate__slideInUp" : ""
                      }
                    >
                      <Tab.Pane eventKey="first">
                        <Row>
                          {projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                              ></ProjectCard>
                            );
                          })}
                        </Row>
                      </Tab.Pane>

                      <Tab.Pane eventKey="section">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <p>
                          Lorem ipsum dolor sit amet consectetur adipisicing
                          elit. Cumque quam, quod neque provident velit, rem
                          explicabo excepturi id illo molestiae blanditiis,
                          eligendi dicta officiis asperiores delectus quasi
                          inventore debitis quo.
                        </p>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
    </section>
  );
};
